import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import TableHead from '@mui/material/TableHead';

const StyledTableHead = styled(TableHead)`
  ${ComponentStyles}
`;

StyledTableHead.propTypes = {
  theme: PropTypes.object
};

export default StyledTableHead;
